export default __webpack_public_path__ + "locales/ar-SA/FilesSettings.json?hash=3edfce92cd36d2fbb9bf3c5f2e5d8828";